import type { UsagePlanId } from "./types";

export const defaultTemplateValues = {
  greeting: "Thank you for visiting",
  satisfactionQuestion: "Were you satisfied with your visit today?",
  unhappyMessage: "We are sorry to hear that.",
  finalThanks: "Thank you for taking a moment to rate your visit.",
};

// Issue #72: plans are billed by distinct phone numbers contacted per period,
// not by raw message ("token") count — numbers are what a customer
// understands, tokens are our own cost driver (tracked separately, see
// BusinessAccount.messages_used_period). Plan ids and prices are unchanged
// from the original token-based plans; only what each plan includes has
// changed. Kept in sync manually with planNumbers in
// api/cmd/rateapi/main.go — no shared source of truth.
export const usagePlans: Array<{
  id: UsagePlanId;
  label: string;
  monthlyPrice: number;
  includedNumbers: number;
}> = [
  {
    id: "starter_250",
    label: "Starter",
    monthlyPrice: 50,
    includedNumbers: 200,
  },
  {
    id: "growth_1000",
    label: "Growth",
    monthlyPrice: 100,
    includedNumbers: 600,
  },
  {
    id: "scale_5000",
    label: "Scale",
    monthlyPrice: 200,
    includedNumbers: 1500,
  },
];

// demoBonusNumbers is the number allowance granted by the one-time $5 demo
// charge — mirrors demoBonusNumbers in api/cmd/rateapi/main.go.
export const demoBonusNumbers = 4;

export const defaultUsagePlanId: UsagePlanId = "starter_250";

export const csvHeaders = [
  "phone_number",
  "consent_attested_by",
] as const;

export const assumedConsentMethod = "other";

export const consentMethods = [
  "web_form",
  "paper_form",
  "checkbox",
  "sms_opt_in",
  "other",
] as const;
